<h2 mat-dialog-title>Translate Trace</h2>

<mat-dialog-content class="mat-typography">
  <pre>{{results.trace}}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
